import { TeamOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Empty, Input, List, Modal, Pagination, Typography } from "antd";
import { useEffect, useState } from "react";
import moment from "moment";
import { openNotification } from "../Notification";
import { mensagemGlobalService } from "../../services/resources/mensagemGlobalService";
import { DATA_FORMATO, OPCOES_TAMANHO_PAGINA } from "../../utils";
import "./mensagemGlobal.css";

const { Title, Text } = Typography;

export const ModalLeituras = ({ visivel, mensagem, onFechar }) => {
  const [loading, setLoading] = useState(false);
  const [consulta, setConsulta] = useState("");
  const [nome, setNome] = useState("");
  const [dados, setDados] = useState([]);
  const [paginacao, setPaginacao] = useState({
    currentPage: 0,
    totalElements: 0,
    size: OPCOES_TAMANHO_PAGINA[1],
  });

  useEffect(() => {
    const timer = setTimeout(() => setNome(consulta.trim()), 400);
    return () => clearTimeout(timer);
  }, [consulta]);

  useEffect(() => {
    if (!visivel || !mensagem?.codigo) {
      return;
    }
    carregar(0, paginacao.size, nome);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visivel, mensagem?.codigo, nome]);

  async function carregar(page, size, filtroNome) {
    setLoading(true);
    try {
      const { data } = await mensagemGlobalService.listarLeituras(mensagem.codigo, {
        page,
        size,
        nome: filtroNome || undefined,
      });
      setDados(data.content || []);
      setPaginacao({
        currentPage: data.currentPage,
        totalElements: data.totalElements,
        size: data.size,
      });
    } catch (error) {
      openNotification(
        "error",
        <strong>Erro ao listar leituras</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    } finally {
      setLoading(false);
    }
  }

  function fechar() {
    setConsulta("");
    setNome("");
    setDados([]);
    onFechar();
  }

  const total = paginacao.totalElements ?? 0;

  return (
    <Modal
      visible={visivel}
      centered
      width="80%"
      style={{ maxWidth: 720 }}
      wrapClassName="modal-mensagem-sistema"
      title={
        <span className="modal-mensagem-titulo">
          <TeamOutlined />
          Quem leu a mensagem
        </span>
      }
      maskClosable={false}
      keyboard
      destroyOnClose
      onCancel={fechar}
      footer={[
        <Button key="fechar" onClick={fechar}>
          fechar
        </Button>,
      ]}
    >
      {mensagem && (
        <>
          <Title level={4} className="mensagem-titulo-destaque">
            {mensagem.titulo}
          </Title>
          <Text type="secondary">
            {total} {total === 1 ? "leitura" : "leituras"}
            {mensagem.dataCadastro
              ? ` · enviada em ${moment(mensagem.dataCadastro).format(
                  `${DATA_FORMATO} HH:mm`
                )}`
              : ""}
          </Text>
          <Input.Search
            allowClear
            className="modal-leituras-busca"
            placeholder="Consultar nome do usuário"
            value={consulta}
            onChange={(event) => setConsulta(event.target.value)}
            onSearch={(valor) => setNome(valor.trim())}
          />
          <div className="conteudo-mensagem-scroll conteudo-mensagem-scroll--modal modal-leituras-lista">
            <List
              loading={loading}
              dataSource={dados}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Nenhuma leitura encontrada"
                  />
                ),
              }}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        style={{ backgroundColor: "var(--main-color)" }}
                        icon={!item.nome ? <UserOutlined /> : undefined}
                      >
                        {item.nome?.charAt(0)}
                      </Avatar>
                    }
                    title={item.nome || "-"}
                    description={
                      item.dataLeitura
                        ? moment(item.dataLeitura).format(`${DATA_FORMATO} HH:mm`)
                        : "-"
                    }
                  />
                </List.Item>
              )}
            />
          </div>
          <div className="modal-leituras-paginacao">
            <Pagination
              size="small"
              current={paginacao.currentPage + 1}
              pageSize={paginacao.size}
              total={total}
              showSizeChanger
              pageSizeOptions={OPCOES_TAMANHO_PAGINA}
              showTotal={(quantidade) => (
                <strong>{quantidade} registros no total</strong>
              )}
              onChange={(page, pageSize) =>
                carregar(page - 1, pageSize, nome)
              }
            />
          </div>
        </>
      )}
    </Modal>
  );
};
